import QueryRooms from "graphql/queries/QueryRooms";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'

export default class FetchRoom {
	static fetchAll( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) {
		GraphqlGroupedBuilder.addQuery( 'rooms', QueryRooms, {
			resultPath: [ 'rooms' ],
			callbackStart,
			callbackError,
			callbackSuccess
		})
	}
}
